// For more info on feature access via PopStar, see
// https://evergreen.corp.amazon.com/atoz-developer-program/develop/feature_access/popstar/
export const FAB_FEATURE_ID = 'myhr_fab';

const hasFeature = (features: string[], feature: string) => features.includes(feature);

export const hasMyHRFABFeature = (features: string[]) => (
    hasFeature(features, FAB_FEATURE_ID)
);
